import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'shared/components/Button/Button';
import { Text } from 'shared/components/Text/Text';
import { LoadingSpinner } from 'shared/components/LoadingSpinner';
import { AutopayBaseContainer } from './AutopayModal.styles';

const AutopayGraphic = React.lazy(() => import('shared/components/icons/AutopayGraphic'));

export type AutopaySetupModalProps = {
  onButtonClick: () => void;
};

export function AutopaySetupModal({ onButtonClick }: AutopaySetupModalProps) {
  const { t } = useTranslation();

  return (
    <AutopayBaseContainer>
      <Suspense fallback={<LoadingSpinner />}>
        <AutopayGraphic />
      </Suspense>

      <Text as="h2" $textAlign="center">
        {t('autopayModal.neverMissABill')}
      </Text>
      <Text as="p">{t('autopayModal.goodbyeToPaperChecks')}</Text>
      <Text as="p">{t('autopayModal.safeSecure')}</Text>

      <Button
        margin="60px 0 0 auto"
        label={t('autopayModal.acknowledge')}
        onClick={onButtonClick}
      />
    </AutopayBaseContainer>
  );
}

export default AutopaySetupModal;
